import { useState, useEffect } from "react";
import { fieldType } from "../../../../types/form";

type Props = {
  dataField: fieldType;
  idx?: any;
  controlledFields?: any;
  type?: string;
};

function Text(props: Props) {
  const { dataField, idx, controlledFields, type } = props;
  const [value, setValue] = useState<any>(null);

  /* Только для формы при добавлении и просмотра карточки документа в сервисе АКАДИЯ - START */

  useEffect(() => {
    if (controlledFields && controlledFields.length > 0) {
      if (controlledFields[idx]["SAP"]) {
        setValue(controlledFields[idx]["SAP"][dataField.key]);
      }
    }
  }, [type, controlledFields]);

  /* Только для формы при добавлении и просмотра карточки документа в сервисе АКАДИЯ - END */

  return (
    <div className={`${dataField.width} mb-5`}>
      <div className="flex flex-row flex-wrap">
        <span className="text-[#6B7280] inline-block min-w-[240px] mr-[10px]">{dataField.title}</span>&nbsp;
        <span className="text-black">{value || "Выберите SAP № технического места"}</span>
      </div>
    </div>
  );
}

export default Text;
